import parent from '../path';

export default `${parent}/admin`;
